import { ShoppingBag } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useBasket } from "@/context/BasketContext";
import { goToSection } from "@/lib/scroll";

export const CartFab = () => {
  const { count, total } = useBasket();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (count === 0) return null;
  return (
    <button
      data-testid="cart-fab"
      onClick={(e) => {
        e.preventDefault();
        goToSection(navigate, pathname, "#order");
      }}
      className="fixed bottom-6 right-6 z-[60] inline-flex items-center gap-2.5 rounded-full bg-[#1C130E] text-[#FDFBF7] pl-5 pr-6 py-3.5 shadow-[0_20px_45px_-15px_rgba(28,19,14,0.6)] hover:bg-[#C85A32] transition-colors"
    >
      <ShoppingBag size={17} />
      <span data-testid="cart-fab-label" className="text-sm font-semibold whitespace-nowrap">
        Basket · {count} item{count > 1 ? "s" : ""} · ₹{total}
      </span>
    </button>
  );
};
